import FSCss from "../../css/overview.module.css";
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { ReactComponent as GreenDot } from "../../assets/icons/greenDotSmall.svg";
import { ReactComponent as DeleteIcon } from "../../../myfin_v2/assets/icons/delete_icon_primary.svg";
import { ReactComponent as SearchIcon } from "../../../myfin_v2/assets/icons/searchPri.svg";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import { Button } from "../../../myfin_v2/elements/Button";
import { Tooltip } from "../../../myfin_v2/elements/Tooltip";
import { ReactComponent as AddIcon } from "../../assets/icons/whitePlus.svg";
import NoteSoftDelete from "../../../Components/templateTabs/NoteSoftDelete/softDelete";
import RestoreSoftDelete from "../../../Components/templateTabs/NoteSoftDelete/restoreSoftDelete";
import commoncss from "../../css/common.module.css";
import { ReactComponent as BackArrow } from "../../assets/icons/left_arrow.svg";
import { ReactComponent as ReplyIcon } from "../../assets/icons/DirectionalArrows.svg";
import { ReactComponent as RecycleBinIcon } from "../../assets/icons/delete_icon_primary.svg";
const getCategoryName = (cat) => {
  switch(cat) {
    case "BS": return "Balance Sheet";
    case "PL": return "P&L Statement";
    case "general notes": return "General Notes";
    case "BS notes": return "Balance Sheet Notes";
    case "PL notes": return "P&L Statement Notes";
    case "socie": return "SOCIE";
    case "cashflow": return "CashFlow";
    case "disclosure": return "Disclosures";
    case "checklist": return "Checklist";
    default: return cat;
  }
}

const FSTopBar = ({history, activeCat, showCashflowWorkings, onToggleCashflowWorkings, showAdjustmentLog,   showAddAdjustment, 
  onOpenAdjustmentLog, onAddAdjustment,
  onBackFromAdjustmentLog, showBin, onOpenBin, onBackFromBin, activeBinSection, selectedBinCount, onDeletePermanently, onRestoreSelected}) => {
  const workspace_data = useSelector((state) => state.WSReducer);
  const { projectData } = useSelector((state) => state.ADJStandaloneReducer);
  const workspaceName = workspace_data?.response?.[0]?.workspace_name || sessionStorage.getItem("adj_workspace_name") || "Workspace";
  const standaloneName = projectData?.project_name || sessionStorage.getItem("adj_standalone_name") || "Financial Statement";
  const project_id = localStorage.getItem("project_id");
  const workspaceId = projectData?.workspace_id || workspace_data?.response?.[0]?._id;
  const standaloneTargetLink = project_id ? `/templateV2/${project_id}` : (workspaceId ? `/financialstatement/${workspaceId}` : "/allWorkspace");

  useEffect(() => {
    if (workspace_data?.response?.[0]?.workspace_name) {
      sessionStorage.setItem("adj_workspace_name", workspace_data.response[0].workspace_name);
    }
  }, [workspace_data]);

  useEffect(() => {
    if (projectData?.project_name) {
      sessionStorage.setItem("adj_standalone_name", projectData.project_name);
    }
  }, [projectData]);

  return (
    <div className={FSCss.w100}>
      <div className={FSCss.uploadLoansMainContainer}></div>

      {showBin ? (
        <div className={`${FSCss.listPageheader}`} style={{ paddingLeft: "15px" }}>
          <div className={FSCss.headerLeftContainer} style={{ display: "flex", alignItems: "center"}}>
            <div className={FSCss.iconContainer} style={{ width: "auto", paddingRight: "15px", paddingLeft: "0" }}>
              <BackArrow className="clickable" style={{ cursor: 'pointer', marginTop: "2px" }} onClick={onBackFromBin} />
            </div>
            <div className={FSCss.topBarHeading} style={{ alignContent: "center", cursor: "pointer" }} onClick={() => history.push(workspaceId ? `/financialstatement/${workspaceId}` : `/allWorkspace`)}>{workspaceName}</div>
            <div className={FSCss.iconDotContainer}>
              <GreenDot />
            </div>
            <div className={FSCss.topBarHeading} style={{ alignContent: "center", cursor: "pointer" }} onClick={() => history.push(standaloneTargetLink)}>{standaloneName}</div>
            <div className={FSCss.iconDotContainer}>
              <GreenDot />
            </div>
            <div className={FSCss.topBarHeading} style={{ alignContent: "center", cursor: "pointer" }} onClick={onBackFromBin}>Standalone Financial Statements - {activeBinSection}</div>
            <div className={FSCss.iconDotContainer}>
              <GreenDot />
            </div>
            <div className={commoncss.headerLable} style={{ alignContent: "center" }}>Deleted Items</div>
          </div>
          <div className={FSCss.headerRightContainer} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            {selectedBinCount > 0 && (
              <span style={{ fontSize: '13px', fontWeight: 600, color: '#205a46', alignContent: 'center' }}>({selectedBinCount}) SELECTED</span>
            )}
            <Button
              btnColor={buttoncss.secondary}
              style={{ color: '#E30000', borderColor: '#CCD5D3', backgroundColor: "transparent" }}
              label="Delete Permanently "
              onClick={onDeletePermanently}
            />
            <Button
              btnColor={buttoncss.primary}
              label="Restore Selected Items"
              onClick={onRestoreSelected}
            />
          </div>
        </div>
      ) : showAdjustmentLog ? (
  <div className={`${FSCss.listPageheader}`} style={{ paddingLeft: "30px" }}>
    <div className={FSCss.headerLeftContainer}>
      <span
        style={{ cursor: "pointer", fontWeight: 500, fontSize: "14px", display: "flex", alignItems: "center", gap: "12px" }}
        onClick={onBackFromAdjustmentLog}
      >
        <BackArrow width={14} height={14} /> Cashflow Workings &nbsp;<span style={{ color: '#2d8861' }}>•</span>&nbsp;<b>{showAddAdjustment ? "Add New Adjustment" : "Adjustment Log"}</b>
      </span>
    </div>
    <div className={FSCss.headerRightContainer}></div>
  </div>

) : showCashflowWorkings ? (
  <div className={`${FSCss.listPageheader}`}>
    <div className={FSCss.headerLeftContainer} style={{ display: "flex", alignItems: "center"}}>
      <div className={FSCss.iconContainer} style={{ width: "auto", paddingRight: "15px", paddingLeft: "0" }}>
        <BackArrow className="clickable" style={{ cursor: 'pointer', marginTop: "1px" }} onClick={onToggleCashflowWorkings} />
      </div>
      <div className={FSCss.topBarHeading} style={{ alignContent: "center", cursor: "pointer" }} onClick={() => history.push(workspaceId ? `/financialstatement/${workspaceId}` : `/allWorkspace`)}>{workspaceName}</div>
      <div className={FSCss.iconDotContainer}>
        <GreenDot />
      </div>
      <div className={FSCss.topBarHeading} style={{ alignContent: "center", cursor: "pointer" }} onClick={() => history.push(standaloneTargetLink)}>{standaloneName}</div>
      <div className={FSCss.iconDotContainer}>
        <GreenDot />
      </div>
      <div className={FSCss.topBarHeading} style={{ alignContent: "center", cursor: "pointer" }} onClick={onToggleCashflowWorkings}>Standalone Financial Statements - Cashflow</div>
      <div className={FSCss.iconDotContainer}>
        <GreenDot />
      </div>
      <div className={commoncss.headerLable} style={{ alignContent: "center" }}>Cashflow Workings</div>
    </div>
    <div className={FSCss.headerRightContainer}>
      <Button
        btnColor={buttoncss.secondary}
        style={{ backgroundColor: "transparent" }}
        label="Adjustment Log"
        onClick={onOpenAdjustmentLog}
      />
      &ensp;
      <Button
        btnColor={buttoncss.primary}
        label={
          <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <AddIcon />
            Add New Adjustment
          </span>
        }
        onClick={onAddAdjustment}
      />
    </div>
  </div>

) : (
  <div className={`${FSCss.listPageheader} ${activeCat === "socie" ? FSCss.socieHeaderFix : ""}`}>
    <div className={FSCss.headerLeftContainer} style={{ display: "flex", alignItems: "center"}}>
      <div className={FSCss.iconContainer} style={{ width: "auto", paddingRight: "15px", paddingLeft: "0" }}>
        <BackArrow className="clickable" style={{ cursor: 'pointer', marginTop: "1px" }} onClick={() => history.push('/preview')} />
      </div>
      <div className={FSCss.topBarHeading} style={{ alignContent: "center", cursor: "pointer" }} onClick={() => history.push(workspaceId ? `/financialstatement/${workspaceId}` : `/allWorkspace`)}>{workspaceName}</div>
      <div className={FSCss.iconDotContainer}>
        <GreenDot />
      </div>
      <div className={FSCss.topBarHeading} style={{ alignContent: "center", cursor: "pointer" }} onClick={() => history.push(standaloneTargetLink)}>{standaloneName}</div>
      <div className={FSCss.iconDotContainer}>
        <GreenDot />
      </div>
      <div className={commoncss.headerLable} style={{ alignContent: "center" }}>Standalone Financial Statements - {getCategoryName(activeCat)}</div>
    </div>
    <div className={FSCss.headerRightContainer}>
      <Tooltip content="Go to mapping" variant="black" position="left" style={{ display: "inline-flex", alignItems: "center", justifyContent: "center"}}>
        <button
          className="clickable"
          style={{ backgroundColor: "transparent", border: "none", padding: "0px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", minWidth: "unset", gap: 0, margin: 0, height: "100%" }}
          onClick={() => { history.push(`/templateV2/${project_id}`); }}
        >
          <span style={{ display: "flex", alignItems: "center", justifyContent: "center", color: "#2D8861", fontSize: "15px", paddingRight: "5px" }}>
            <ReplyIcon />
          </span>
        </button>
      </Tooltip>
      &ensp;
      {activeCat !== "socie" && activeCat !== "cashflow" && (
        <>
          <Button
            btnColor={buttoncss.secondary}
            style={{ backgroundColor: "transparent", minWidth: "50px", padding: "8px 14px", margin: "0" }}
            label={
              <span style={{ display: "flex", alignItems: "center", gap: "6px", fontSize: "14px" }}>
                <RecycleBinIcon width={18} height={18} style={{ marginTop: "-1px" }} />
                 Bin
              </span>
            }
            onClick={onOpenBin}
          />
          &ensp;
        </>
      )}
      {onToggleCashflowWorkings && (
        <>
           <Button
            btnColor={buttoncss.secondary}
            style={{ backgroundColor: "transparent" }}
            label="Cashflow Workings"
            onClick={onToggleCashflowWorkings}
          /> 
          &ensp;
        </>
      )}
      <Button
        btnColor={buttoncss.secondary}
        style={{ backgroundColor: "transparent" }}
        label="Link Registers"
        onClick={() => { history.push("/link-register"); }}
      />
      &ensp;
      <Button
        btnColor={buttoncss.primary}
        label="Finalise FS"
        onClick={() => { history.push("/finalize-fs"); }}
      />
    </div>
  </div>
)}
    </div>
  );
};

export default FSTopBar;